// Modelo para la compañía relacionada (referencia simplificada)
export interface CompanyTaxesCompany {
  id: number;
  name: string;
  currencyId: number;
  currency: any | null;
  odooEntityId: number;
}

// Modelo principal para impuestos de compañía
export interface CompanyTaxes {
  id: number;
  name: string;
  description: string;
  taxType: string;
  fiscalValidity: string;
  invoiceTag: string;
  amount: number;
  amountType: string;
  companyId: number;
  countryId?: number;
  isActive: boolean;
  company?: CompanyTaxesCompany;
}

// Para crear (sin id requerido, company opcional)
export type CompanyTaxesCreate = Omit<CompanyTaxes, 'id' | 'company'>;

// Para actualizar (id obligatorio, resto opcional, company opcional)
export type CompanyTaxesUpdate = Partial<
  Omit<CompanyTaxes, 'id' | 'company'>
> & { id: number };

// Tipo de CompanyTaxes (catálogo)
export interface CompanyTaxesType {
  id: number;
  name: string;
  isActive: boolean;
}
